import { useSettings } from '@shared/contexts/SettingContext';
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

const Logo = ({ className }) => {
  const { settings } = useSettings();
  return (
    <div className="flex items-center justify-center">
      <Link
        to="/"
        className="group flex items-center gap-2 transition-all duration-200 hover:scale-105"
      >
        <img
          src="/skypostal-logo.svg"
          alt={settings?.siteName || "SkyPostal"}
          className={cn(
            "h-8 w-auto transition-all duration-200 group-hover:brightness-110",
            className
          )}
        />
      </Link>
    </div>
  );
};

export default Logo;
